import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import OrderLookup from './pages/OrderLookup';
import GenerateLink from './pages/GenerateLink';
import PaymentBuilder from './pages/PaymentBuilder';
import PaymentStatus from './pages/PaymentStatus';
import PaymentHistory from './pages/PaymentHistory';
import PaymentPlanEdit from './pages/PaymentPlanEdit';
import Conciliation from './pages/Conciliation';
import DevTools from './pages/DevTools';
import AdminSettings from './pages/AdminSettings';
import ChangePassword from './pages/ChangePassword';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

function AppRoutes() {
  const { isAuthenticated } = useAuth();

  return (
    <Routes>
      <Route
        path="/login"
        element={isAuthenticated ? <Navigate to="/orders" replace /> : <Login />}
      />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout>
              <Navigate to="/orders" replace />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/orders"
        element={
          <ProtectedRoute>
            <Layout>
              <OrderLookup />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/payment-links"
        element={
          <ProtectedRoute>
            <Layout>
              <GenerateLink />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/orders/:orderId/payment"
        element={
          <ProtectedRoute>
            <Layout>
              <PaymentBuilder />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/payment-plans/:planId"
        element={
          <ProtectedRoute>
            <Layout>
              <PaymentStatus />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/payment-plans/:planId/edit"
        element={
          <ProtectedRoute>
            <Layout>
              <PaymentPlanEdit />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/history"
        element={
          <ProtectedRoute>
            <Layout>
              <PaymentHistory />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/conciliation"
        element={
          <ProtectedRoute>
            <Layout>
              <Conciliation />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/change-password"
        element={
          <ProtectedRoute>
            <Layout>
              <ChangePassword />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/settings"
        element={
          <ProtectedRoute>
            <Layout>
              <AdminSettings />
            </Layout>
          </ProtectedRoute>
        }
      />
      {process.env.NODE_ENV !== 'production' && (
        <Route
          path="/dev-tools"
          element={
            <ProtectedRoute>
              <Layout>
                <DevTools />
              </Layout>
            </ProtectedRoute>
          }
        />
      )}
    </Routes>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </Router>
  );
}

export default App;
